// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ready-made {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 40px 80px;
}

.ready-made-header {
  text-align: center;
  margin-bottom: 48px;
}

.ready-made-title {
  font-family: var(--font-display);
  font-size: clamp(48px, 8vw, 100px);
  color: var(--gold);
  text-transform: uppercase;
  line-height: 1;
  margin-bottom: 12px;
}

.ready-made-subtitle {
  font-family: var(--font-body);
  font-size: clamp(14px, 1.4vw, 20px);
  color: var(--dark);
  opacity: 0.7;
}

.category-filter {
  display: flex;
  gap: 12px;
  margin-bottom: 40px;
  flex-wrap: wrap;
  justify-content: center;
}

.category-btn {
  padding: 10px 24px;
  background-color: transparent;
  border: 2px solid var(--border);
  border-radius: 24px;
  color: var(--dark);
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 400;
  transition: all 0.3s ease;
}

.category-btn:hover {
  border-color: var(--gold);
  color: var(--gold);
}

.category-btn.active {
  background-color: var(--dark);
  border-color: var(--dark);
  color: var(--bg);
}

.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 28px;
}

@media (max-width: 768px) {
  .ready-made {
    padding: 20px 16px 60px;
  }

  .ready-made-header {
    margin-bottom: 32px;
  }

  .items-grid {
    grid-template-columns: repeat(auto-fill, minmax(min(240px, 100%), 1fr));
    gap: 16px;
  }

  .category-btn {
    padding: 8px 18px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ReadyMade.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uEAAuE;IACvE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".ready-made {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 40px 80px;\n}\n\n.ready-made-header {\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.ready-made-title {\n  font-family: var(--font-display);\n  font-size: clamp(48px, 8vw, 100px);\n  color: var(--gold);\n  text-transform: uppercase;\n  line-height: 1;\n  margin-bottom: 12px;\n}\n\n.ready-made-subtitle {\n  font-family: var(--font-body);\n  font-size: clamp(14px, 1.4vw, 20px);\n  color: var(--dark);\n  opacity: 0.7;\n}\n\n.category-filter {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 40px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.category-btn {\n  padding: 10px 24px;\n  background-color: transparent;\n  border: 2px solid var(--border);\n  border-radius: 24px;\n  color: var(--dark);\n  font-family: var(--font-body);\n  font-size: 14px;\n  font-weight: 400;\n  transition: all 0.3s ease;\n}\n\n.category-btn:hover {\n  border-color: var(--gold);\n  color: var(--gold);\n}\n\n.category-btn.active {\n  background-color: var(--dark);\n  border-color: var(--dark);\n  color: var(--bg);\n}\n\n.items-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 28px;\n}\n\n@media (max-width: 768px) {\n  .ready-made {\n    padding: 20px 16px 60px;\n  }\n\n  .ready-made-header {\n    margin-bottom: 32px;\n  }\n\n  .items-grid {\n    grid-template-columns: repeat(auto-fill, minmax(min(240px, 100%), 1fr));\n    gap: 16px;\n  }\n\n  .category-btn {\n    padding: 8px 18px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
